import { Icon, TextField } from "@shopify/polaris";
import { SearchMajor } from "@shopify/polaris-icons";
import React, { useCallback, useState } from "react";

interface Props {
  search: string;
  setSearch: (value: string) => void;
}

export function FilterSearch(props: Props) {
  const [searchInput, setSearchInput] = useState(props.search);

  const handleChangeSearch = useCallback(
    (value) => {
      setSearchInput(value);
      if (value === "") {
        props.setSearch("");
      }
    },
    [props],
  );

  const handleEnter = useCallback(
    (e: any) => {
      if (e.keyCode === 13) {
        props.setSearch(searchInput);
      }
    },
    [searchInput, props],
  );

  return (
    <div onKeyDown={handleEnter}>
      <TextField
        prefix={<Icon source={SearchMajor as any} />}
        autoComplete="off"
        label
        labelHidden
        value={searchInput}
        onChange={handleChangeSearch}
        placeholder="SHP#######"
      />
    </div>
  );
}
